import React from "react";
import { cn } from "../../../../lib/utils";
import { Combobox } from "../../../ui/combobox";
import {
  TARGET_AREA_PRESETS,
  TARGET_OPTIONS_WITH_CATEGORIES,
} from "../../../../config/targets";
import { matchingMusclePreset } from "../../../../utils/generateSummaries";

const MusclesDetail = ({ targetAreas, onChange }) => {
  const list = Array.isArray(targetAreas) ? targetAreas : [];
  const preset = matchingMusclePreset(list);
  return (
    <>
      <div className="space-y-2">
        <p className="text-xs font-semibold text-muted-foreground">Focus</p>
        <div className="flex flex-wrap gap-1.5">
          <button
            type="button"
            aria-pressed={list.length === 0}
            onClick={() => onChange([])}
            className={chip(list.length === 0)}
          >
            No focus
          </button>
          {Object.entries(TARGET_AREA_PRESETS).map(([name, muscles]) => (
            <button
              key={name}
              type="button"
              aria-pressed={preset === name}
              onClick={() => onChange([...muscles])}
              className={chip(preset === name)}
            >
              {name}
            </button>
          ))}
        </div>
      </div>
      <div className="space-y-2">
        <p className="text-xs font-semibold text-muted-foreground">
          Specific muscles
        </p>
        <Combobox
          multiple
          options={TARGET_OPTIONS_WITH_CATEGORIES}
          value={list}
          onChange={onChange}
          renderChips
          placeholder="Search muscles to add..."
          className="w-full bg-background/50 text-sm"
        />
      </div>
    </>
  );
};

export const chip = (on) =>
  cn(
    "rounded-full border px-3 py-1.5 text-[13px] transition-colors",
    on
      ? "border-primary/50 bg-primary/10 font-semibold text-primary"
      : "border-border bg-background/40 text-foreground hover:border-primary/40",
  );

export default MusclesDetail;
